<!--
 * @Description  : 知识库管理 - 类型管理
 * @Author       : zcc
 * @Date         : 2025-04-23 14:36:59
 * @LastEditors  : zcc
 * @LastEditTime : 2025-05-07 08:59:58
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-type-management\index.vue
-->
<template>
  <div class="h100 library-type-management">
    <vxe-grid ref="xGrid" v-bind="gridOptions">
      <template #toolbar_buttons>
        <div class="title">
          类型管理
        </div>
      </template>
      <template #toolbar_tools>
        <dropdown
          :levelList="levelList"
          :largeLevel="true"
          @levelChange="expandByHierarch"
        ></dropdown>
        <!-- 新增按钮 -->
        <el-button
          type="primary"
          class="ml20"
          @click="tableBtnClick('add', {})"
        >
          {{ "新增类型" }}
        </el-button>
      </template>
      <template #tool="{ row, $rowIndex }">
        <!-- level层级到5级的时候禁用 -->
        <!-- <el-button
            v-if="row.level != 5"
            type="text"
            class="table-operation-icon"
            @click="tableBtnClick('nodeAdd', row, $rowIndex)"
          >
            <svg-icon icon-class="add"></svg-icon>
          </el-button> -->
        <el-button
          type="success"
          size="small"
          round
          plain
          class="table-btn"
          @click="tableBtnClick('nodeAdd', row, $rowIndex)"
          v-if="row.level != 5"
        >
          添加
        </el-button>
        <!-- <el-button
            type="text"
            class="table-operation-icon"
            @click="tableBtnClick('view', row)"
          >
            <svg-icon icon-class="eye-open"></svg-icon>
          </el-button> -->
        <el-button
          type="success"
          size="small"
          round
          plain
          class="table-btn"
          @click="tableBtnClick('view', row)"
        >
          查看
        </el-button>
        <!-- <el-button
            type="text"
            class="table-operation-icon"
            @click="tableBtnClick('edit', row)"
          >
            <svg-icon icon-class="edits"></svg-icon>
          </el-button> -->
        <el-button
          type="success"
          size="small"
          round
          plain
          class="table-btn"
          @click="tableBtnClick('edit', row)"
        >
          编辑
        </el-button>
        <!-- 
          <el-button
            v-if="row.level != 1 && !row.children"
            type="text"
            class="table-operation-icon"
            @click="handleRelate(row)"
          >
            <svg-icon icon-class="guanlian"></svg-icon>
          </el-button> -->
        <el-button
          type="success"
          size="small"
          round
          plain
          class="table-btn"
          @click="handleRelate(row)"
          v-if="row.level != 1 && !row.children"
        >
          关联
        </el-button>
        <el-button
          type="danger"
          size="small"
          round
          plain
          class="table-btn"
          @click="deleteDicType(row)"
          v-if="!row.children && row.docManages == 0"
        >
          删除
        </el-button>
      </template>

      <!-- 排序移动 -->
      <template #sort="{ row, $rowIndex }">
        <el-button
          type="text"
          class="table-operation-icon"
          @click="handleMove('up', row, $rowIndex)"
          :disabled="$rowIndex == 0"
        >
          <svg-icon icon-class="shengxu"></svg-icon>
        </el-button>
        <el-button
          type="text"
          class="table-operation-icon"
          @click="handleMove('down', row, $rowIndex)"
          :disabled="row.max == 1"
        >
          <svg-icon icon-class="jiangxu"></svg-icon>
        </el-button>
      </template>
      <template #status="{ row }">
        <vxe-switch
          class="ml10"
          v-model="row.status"
          open-label="启用"
          close-label="禁用"
          :open-value="1"
          :close-value="0"
          @change="statusChange($event, row)"
        ></vxe-switch>
      </template>
      <!-- 节点类型中文 -->
      <template #level="{ row }">
        <span>{{ `${toChinese(row.level)}级类型` }}</span>
      </template>

      <!-- 检索页地址 -->
      <template #subdomain="{ row }">
        <span
          v-if="row.level == 1"
          class="link-class"
          @click="subdomainClick(row.subdomain)"
        >
          {{ row.subdomain }}
        </span>
      </template>

      <!-- 已关联文档 -->
      <template #docManages="{ row }">
        <span @click="handleRelate(row, 'view')" class="link-class">
          {{ row.docManages }}
        </span>
      </template>
    </vxe-grid>

    <!-- 添加文库类型 -->
    <addTypeDialog
      ref="addTypeDialog"
      @updateSearch="getTreeList"
      v-if="dialog.visible"
      :dialogObj="dialog"
      @success="onSuccess"
    ></addTypeDialog>

    <!-- 已关联文库 -->
    <relate-dialog
      ref="relateDialog"
      v-if="showRelate"
      @updateSearch="getTreeList"
    ></relate-dialog>
  </div>
</template>

<script>
import dropdown from "components/dropdown/dropdown.vue";
import * as typeApi from "api/modules/library/library-type-management/index.js";
import { Snowflake } from "node-snowflake";
import { returnChinese } from "@/utils/tools";
import addTypeDialog from "./components/addTypeDialog.vue";
import relateDialog from "./components/relate-dialog.vue";
import XEUtils from "xe-utils";
export default {
  name: "library-type-management",
  components: { dropdown, addTypeDialog, relateDialog },
  data() {
    return {
      levelList: [], //展开层级
      gridOptions: {
        loading: false,
        showOverflow: true,
        showHeaderOverflow: true,
        height: "auto",
        autoResize: true,
        border: true,
        data: [], // 表格数据
        scrollY: {
          enabled: true, //滚动模式
          gt: 10 //指定大于行数就滚动
        },
        // 工具栏配置
        toolbarConfig: {
          custom: false,
          slots: {
            tools: "toolbar_tools",
            buttons: "toolbar_buttons"
          }
        },
        // 列配置
        columnConfig: {
          resizable: true
        },
        editConfig: {
          trigger: "click",
          mode: "cell",
          enabled: false
          // enabled: isEdit
        },
        // 行配置
        rowConfig: {
          isHover: true,
          isCurrent: true,
          keyField: "id"
        },
        treeConfig: {
          childrenField: "children",
          expandAll: true,
          parentField: "pid",
          indent: 10,
          transform: false,
          rowField: "id",
          iconOpen: "vxe-icon-folder-open",
          iconClose: "vxe-icon-folder"
        },
        columns: []
      },
      sortId: "", //当前行id
      dialog: {
        title: "新建文库类型",
        visible: false,
        width: "1000px",
        showFooter: false,
        type: "view",
        id: "",
        node: "",
        row: {}
      }, //新增/编辑/查看文库类型对话框
      showRelate: false, // 已关联文件弹框显隐
      largeLevel: true
    };
  },
  mounted() {
    this.getStaticColumns(); // 静态数组 (全列头)
    this.getTreeList(); // 获取列表
  },
  methods: {
    //静态数组 (全列头)
    getStaticColumns() {
      let staticColumns = [
        {
          type: "seq",
          title: "序号",
          width: 100,
          visible: true
        },
        {
          field: "sname",
          title: "文库类型名称",
          minWidth: 280,
          treeNode: true,
          align: "left",
          headerAlign: "left",
          visible: true
        },
        {
          field: "shortName",
          title: "节点简称",
          minWidth: 140,
          align: "left",
          headerAlign: "left",
          visible: true
        },
        {
          field: "level",
          title: "节点类型",
          minWidth: 140,
          align: "left",
          headerAlign: "left",
          visible: true,
          slots: { default: "level" }
        },
        {
          field: "subdomain",
          title: "检索页地址",
          minWidth: 200,
          align: "left",
          headerAlign: "left",
          visible: true,
          slots: { default: "subdomain" }
        },
        {
          field: "docManages",
          title: "已关联文档",
          minWidth: 100,
          align: "left",
          headerAlign: "left",
          visible: true,
          slots: { default: "docManages" }
        },
        {
          field: "remark",
          title: "说明",
          minWidth: 280,
          align: "left",
          headerAlign: "left",
          visible: true
        },
        {
          field: "status",
          title: "状态",
          width: 100,
          visible: true,
          align: "center",
          slots: { default: "status" }
        },
        {
          field: "sort",
          title: "排序",
          minWidth: 70,
          align: "left",
          visible: true,
          slots: { default: "sort" }
        },
        {
          title: "操作",
          field: "tool",
          width: 300,
          visible: true,
          slots: { default: "tool" }
        }
      ];
      // 赋值
      this.gridOptions.columns = staticColumns;
      this.$nextTick(() => {
        this.$refs.xGrid && this.$refs.xGrid.refreshColumn();
      });
    },
    //检索页地址
    subdomainClick(subdomain) {
      window.open(subdomain, "_blank");
    },
    //获取表格数据
    getTreeList() {
      // 获取列表数据
      this.gridOptions.loading = true;
      this.gridOptions.data = [];
      this.levelList = [];
      typeApi
        .libDocTypeTreeList({})
        .then(res => {
          if (res.code == 0) {
            this.gridOptions.data = res.data.list; // 表格数据
            this.levelList = res.data.levelList; // 展示层级
            if (this.largeLevel && this.levelList?.length > 0) {
              this.activeLevel = this.levelList[this.levelList.length - 1];
            } // 默认展开最高层级
            this.changeLevel(this.activeLevel.value, "level");
          }
          this.gridOptions.loading = false;
        })
        .catch(err => {
          this.gridOptions.loading = false;
        });
    },
    //层级下拉
    expandByHierarch(item) {
      this.activeLevel = item;
      this.changeLevel(item.value, "level");
    },
    //切换展开层级
    changeLevel(data, type) {
      this.gridOptions.loading = true;
      // 先关闭所有
      this.$nextTick(() => {
        this.$refs.xGrid.clearTreeExpand();
        // 找到对应层级的数组
        let arr = XEUtils.filterTree(
          this.gridOptions.data,
          x => x.level < data
        );
        // 按层级展开
        this.$refs.xGrid.setTreeExpand(arr, true);
      });
      setTimeout(() => {
        this.gridOptions.loading = false;
      }, 200);
    },
    // 关联文档
    handleRelate(row, type) {
      this.showRelate = true; // 弹窗显示
      setTimeout(() => {
        this.$refs.relateDialog &&
          this.$refs.relateDialog.initDialog(row, type);
      }, 200);
    },
    // 删除节点
    deleteDicType(row) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          typeApi
            .delDocType({ id: row.id })
            .then(res => {
              if (res.code == 0) {
                this.$message.success("删除成功！");
                this.getTreeList();
              }
            })
            .catch(err => {});
        })
        .catch(() => {
          this.$message.success({ message: "已取消删除!" });
        });
    },
    // 转换成中文
    toChinese(data) {
      let str = returnChinese(data);
      return str;
    },
    //状态启用禁用
    statusChange(e, row) {
      this.$confirm("确认修改该项状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: row.id,
            status: e.value ? 1 : 0 //变更状态 0-禁用 1-启用
          };
          typeApi.updateStatus(params).then(res => {
            if (res.code == 0) {
              this.$message.success({
                message: e.value ? "启用成功！" : "禁用成功！"
              });
              // 状态更改后需要重新获取数据
              this.getTreeList();
            }
          });
        })
        .catch(() => {
          if (e.value == 0) row.status = 1;
          else row.status = 0;
          this.$message.success({ message: "已取消修改!" });
        });
    },
    // 上下移动排序
    handleMove(type, row, index) {
      this.sortId = row.id;
      let item = {};
      let _index = index;
      let pObj = XEUtils.findTree(this.gridOptions.data, x => x.id == row.pid);
      if (pObj) {
        // 有子集的情况
        item = pObj.item;
        if (type == "up") {
          let idB = item.children[_index - 1].id;
          this.updateDeptSort(row.id, idB);
        } else {
          let idB = item.children[_index + 1].id;
          this.updateDeptSort(row.id, idB);
        }
      } else {
        // 无子集或顶级的情况
        if (type == "up") {
          let idB = this.gridOptions.data[_index - 1].id;
          this.updateDeptSort(row.id, idB);
        } else {
          let idB = this.gridOptions.data[_index + 1].id;
          this.updateDeptSort(row.id, idB);
        }
      }
    },
    // 排序方法
    updateDeptSort(idA, idB) {
      typeApi.changeSort({ idA: idA, idB: idB }).then(res => {
        this.$message.success({ message: "操作成功" });
        this.getTreeList(); // 重新获取数据
      });
    },
    //编辑，删除 查看 按钮操作
    tableBtnClick(type, row) {
      //保存当前行
      this.nodeRow = row;
      switch (type) {
        // 新增属性 -- 打开弹窗
        case "add":
          this.dialog.id = Snowflake.nextId();
          this.dialog.title = "新建文库类型";
          break;
        // 编辑属性 -- 打开弹窗
        case "edit":
          this.dialog.row = row;
          this.dialog.title = "编辑文库类型";
          break;
        // 查看属性 -- 打开弹窗
        case "view":
          this.dialog.row = row;
          this.dialog.title = "查看文库类型";
          break;
        case "nodeAdd":
          this.dialog.row = row;
          this.dialog.title = "添加文库类型子节点";
          break;
      }
      this.dialog.type = type;
      setTimeout(() => {
        this.dialog.visible = true;
      }, 200);
    },
    // 保存回调
    onSuccess(row) {
      // console.log("row, onSuccess :>> ", row);
      this.getTreeList();
      // if (row != "add") {
      //   console.log("111 :>> ", 111);
      //   // 添加子集和编辑的情况下
      //   if (this.dialog.type == "edit") {
      //     console.log("222 :>> ", 222);
      //     Object.keys(this.nodeRow).forEach(key => {
      //       this.nodeRow[key] = row[key];
      //     });
      //     this.getTreeList();
      //   } else {
      //     console.log("333 :>> ", 333);
      //     // nodeAdd
      //     this.nodeRow.children = this.nodeRow.children
      //       ? this.nodeRow.children
      //       : [];
      //     row.status = 1;
      //     this.nodeRow.children.push(row);
      //     setTimeout(() => {
      //       this.$refs.xGrid.setTreeExpand(this.nodeRow, true);
      //     });
      //   }
      // } else {
      //   console.log("444 :>> ", 444);
      //   this.getTreeList();
      // }
    }
  },
  computed: {}
};
</script>

<style scoped lang="less">
.library-type-management {
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    padding: 15px 0;
  }
  .link-class {
    color: #3ba1ff;
    cursor: pointer;
  }
  /deep/ .vxe-table--render-default.vxe-editable .vxe-body--column {
    height: 40px;
  }
}
</style>
